import React, {
    useState,
    useEffect
} from "react";
import {
    Row,
    Modal,
    Form
} from "react-bootstrap";
import { getFromLS } from "../../../utils/storage";
import { FormContext } from "../../../reusable-components/InputFields/FormContext";
import Element from '../../../reusable-components/InputFields/input';
import { logout } from "../../../utils";
import { v4 } from "uuid";
import { toast } from "react-toastify";
import { makeCygnusApiCall } from '../../../api/api';

export const UploadKonePdf = (props) => {
    const token = getFromLS("token")
    const [elements, setElements] = useState([{
        "id": v4(),
        "label": "Upload K1 file",
        "mandatory": false,
        "approval": false,
        "disabled": false,
        "placeholder": "Upload K1 file",
        "type": "file",
        "example": null,
        "pivot": true,
        "pivotreverse": false,
        "value": "",
        "width": 12,
        "filelimit": "multiple"
    }]);

    const handleChange = (field_id, event) => {
        const newElements = [...elements]
        newElements.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'file':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            const newFullSchema = [...newElements]
            setElements(newFullSchema)
        });
        // console.log(newElements)
    }

    /**
     * Update the values of fields in the PREVIEW form
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const uploadKone = async (files) => {
        props.setfileuploading(true)
        const payloadFormat = new FormData();
        // console.log("FILES: ", files)
        for (let file of files) {
            payloadFormat.append("File", file)
        }
        const data = await makeCygnusApiCall({
            type: "POST",
            payload: payloadFormat,
            payload_is_file: true,
            url: "/k1/upload/",
            show_message: false,
            customized_success_message: "Successfully uploaded your K-1 file/s.",
            customized_failure_message: "Unable to fetch your K-1 file/s., please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while fetching your K-1 file/s., please contact support and attach a screenshot.",
            isblob: false
        })
        if (data.success) {
            props.refresh()
        }
        props.onHide()
        props.setfileuploading(false)
    }

    useEffect(() => {
        // console.log("UPLOAD KONE ELEMENTS: ", elements)
        if (elements[0]["value"] !== "") {
            uploadKone(elements[0]["value"])
        }
    }, [elements])


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className={"smallmodal"}
        >
            <Modal.Header closeButton style={{ padding: 0, margin: 0 }}>
            </Modal.Header>
            <Modal.Body style={{ padding: 0, margin: 0 }}>
                <FormContext.Provider value={{ handleChange }}>
                    <Form>
                        <Row className="no-gutter">
                            {
                                elements &&
                                elements.map((field, i) =>
                                    <Element
                                        key={i}
                                        field={field}
                                        md={12}
                                    />)
                            }
                        </Row>
                    </Form>
                </FormContext.Provider>
            </Modal.Body>
        </Modal>
    )
}